// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartTotalDisplayStyles } from "@eisinc/Overrides/Components/CartTotalDisplay";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

const sharedLabelStyles = { ...fontConfig.singleLineSmall };
const sharedValueStyles = {
    ...fontConfig.singleLineSmall,
    weight: fontConfig.weight.medium,
};

cartTotalDisplayStyles.wrappingContainer = {
    css: css`
        width: 100%;
    `,
};

cartTotalDisplayStyles.summaryOrdercontainer = {
    css: css`
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

cartTotalDisplayStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 0 12px;
        align-items: center;
    `,
};

cartTotalDisplayStyles.titleWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: 12px;
        background: ${color("common.ui2")};
        align-items: center;
    `,
};

cartTotalDisplayStyles.cartUrl = {
    typographyProps: {
        ...fontConfig.singleLinexSmall,
        weight: fontConfig.weight.medium,
    },
};

cartTotalDisplayStyles.labelGridItem = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

cartTotalDisplayStyles.valueGridItem = {
    css: css`
        min-width: 70px;
        min-width: 70px;
        display: flex;
        justify-content: flex-end;
    `,
};

cartTotalDisplayStyles.loadingSpinner = {
    size: 17,
    color: "primary.main",
    css: css`
        margin-top: auto;
        margin-bottom: auto;
        margin-left: auto;
    `,
};

cartTotalDisplayStyles.freeShippingStyle = {
    css: css`
        font-size: ${fontConfig.singleLinexSmall.size}px;
        line-height: ${fontConfig.singleLinexSmall.lineHeight};
        font-style: italic;
    `,
};

cartTotalDisplayStyles.freeShippingWrapperStyle = {
    css: css`
        padding: 0 12px;
    `,
};

cartTotalDisplayStyles.subtotalLabel = { ...sharedLabelStyles };
cartTotalDisplayStyles.subtotalValue = { ...sharedValueStyles };

cartTotalDisplayStyles.shippingAndHandlingLabel = { ...sharedLabelStyles };
cartTotalDisplayStyles.shippingAndHandlingValue = { ...sharedValueStyles };

cartTotalDisplayStyles.taxLabel = { ...sharedLabelStyles };
cartTotalDisplayStyles.taxValue = { ...sharedValueStyles };

cartTotalDisplayStyles.promotionLabel = { ...sharedLabelStyles };
cartTotalDisplayStyles.promotionValue = { ...sharedValueStyles };

cartTotalDisplayStyles.discountsLabel = { ...sharedLabelStyles };
cartTotalDisplayStyles.discountsValue = { ...sharedValueStyles };

cartTotalDisplayStyles.totalLabel = {
    ...fontConfig.singleLineRegular,
};

cartTotalDisplayStyles.totalValue = {
    ...fontConfig.singleLineRegular,
    weight: fontConfig.weight.medium,
};

cartTotalDisplayStyles.orderSummaryValueContainer = {
    css: css`
        display: flex;
        gap: 12px;
    `,
};

cartTotalDisplayStyles.orderSummaryLabel = {
    variant: "h5",
    as: "p",
    css: css`
        margin-bottom: 0;
    `,
};

cartTotalDisplayStyles.orderSummaryValue = {
    ...fontConfig.singleLineSmall,
};

cartTotalDisplayStyles.totalWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding-top: 12px;
        align-items: center;
        margin: 12px 12px 0;
        border-top: 1px solid ${color("common.border")};
        width: unset;
    `,
};
